import { useIntl } from 'react-intl';

export const useErrors = () => {
  const intl = useIntl();

  const RETRY_ERROR = intl.formatMessage({
    id: 'UseErrors.retryError',
    defaultMessage: 'An error occurred, please try again.',
    description: 'Generic retry error message',
  });

  const SYSTEM_ERROR = intl.formatMessage({
    id: 'UseErrors.systemError',
    defaultMessage:
      'Apologies, the system is currently experiencing technical difficulties and cannot process your request at this time.',
    description: 'System technical difficulties error message',
  });

  const RETRY_LATER_ERROR = intl.formatMessage({
    id: 'UseErrors.retryLaterError',
    defaultMessage: 'Something went wrong. Please try again later.',
    description: 'Try again later error message',
  });

  const REFRESH_AND_RETRY_ERROR = intl.formatMessage({
    id: 'UseErrors.refreshAndRetryError',
    defaultMessage: 'An error occurred. Refresh the page and try again.',
    description: 'Refresh page and retry error message',
  });

  return {
    RETRY_ERROR,
    SYSTEM_ERROR,
    RETRY_LATER_ERROR,
    REFRESH_AND_RETRY_ERROR,
  };
};
